var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},_vm._l((_vm.max),function(n,index){return _c('div',{key:index,staticClass:"progress__wrapper"},[_c('div',{staticClass:"progress__item",class:{'progress__item--active': n <= _vm.current}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }